<template>
  <div class="online-command-loading-skeleton">
    <div class="d-flex flex-wrap mb-3">
      <b-skeleton width="150px" height="38px" class="me-2 mb-2" />
      <b-skeleton width="180px" height="38px" class="me-2 mb-2" />
      <b-skeleton width="220px" height="38px" class="mb-2" />
    </div>

    <div class="p-3 text-muted">
      <b-skeleton width="180px" height="24px" class="mb-3" />

      <div class="align-items-baseline align-self-center d-flex justify-content-between mb-3">
        <div class="col-4">
          <b-skeleton width="100%" height="38px" />
        </div>
        <b-skeleton width="110px" height="38px" />
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between mb-3">
            <b-skeleton width="120px" height="38px" />
            <b-skeleton width="220px" height="38px" />
          </div>

          <div class="table-responsive my-3 border border-1">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th v-for="(width, index) in headerWidths" :key="`header-${index}`">
                    <b-skeleton :width="width" />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in 5" :key="row">
                  <td v-for="(width, index) in rowWidths" :key="`${row}-${index}`">
                    <b-skeleton :width="width" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerWidths: ['140px', '120px', '140px', '90px', '120px', '160px', '130px'],
      rowWidths: ['150px', '110px', '130px', '80px', '110px', '170px', '120px'],
    }
  },
}
</script>
